const generalDict = {
  ARTICLES: "Articles",
  VIEW_MORE: "View more",
  SOCIALS: "Socials",
};
export default generalDict;
